// extracted by mini-css-extract-plugin
module.exports = {"slider":"Advices-module--slider--28UbG","link":"Advices-module--link--1-XMu","advices":"Advices-module--advices--1p9R2","dots":"Advices-module--dots--VCnrU"};